/* eslint-disable react/display-name */
import IframeResizer from 'iframe-resizer-react';

import { Text } from 'app/shared/ui';
import { ListItems } from 'app/shared/components/ListItems/ListItems';

import { HeroImage } from '../../../components/HeroImage';

import {
  GridContainerSt,
  TitleContainerSt,
  TitleSt,
  CarSale24Form,
  TitleWhiteSt,
  ListItemsContainerSt,
  IFrameContainerSt,
  IntroContainerSt,
  ImageContainerSt,
  BadgeMobileContainerSt,
  Badge,
} from './SellMyCarOnline.css';

interface ISellMyCarOnlineProps {
  iframeSrc: string;
  isFlag244ShowCarsale24Form?: boolean;
}

export const SellMyCarOnline = ({
  iframeSrc,
  isFlag244ShowCarsale24Form = false,
}: ISellMyCarOnlineProps): JSX.Element => (
  <GridContainerSt>
    <IntroContainerSt>
      <TitleContainerSt mb={[24, 32, 40]}>
        <BadgeMobileContainerSt>
          <Badge />
        </BadgeMobileContainerSt>
        <TitleSt>
          Mein Auto online <TitleWhiteSt>verkaufen</TitleWhiteSt>
        </TitleSt>
      </TitleContainerSt>

      <ListItemsContainerSt>
        <ListItems>
          <Text
            fontSize={[16, null, 20, 24]}
            lineHeight={[2, null, null, 1.66]}
            fontWeight="bold"
          >
            Top-Preise durch den Verkauf an Meistbietenden
          </Text>
          <Text
            fontSize={[16, null, 20, 24]}
            lineHeight={[2, null, null, 1.66]}
            fontWeight="bold"
          >
            Stressfrei inkl. kostenloser Abholung
          </Text>
          <Text
            fontSize={[16, null, 20, 24]}
            lineHeight={[2, null, null, 1.66]}
            fontWeight="bold"
          >
            Verkauf nur an geprüfte Händler
          </Text>
        </ListItems>
      </ListItemsContainerSt>

      <ImageContainerSt>
        <Badge />
        <HeroImage />
      </ImageContainerSt>
    </IntroContainerSt>

    <IFrameContainerSt>
      <CarSale24Form>
        {isFlag244ShowCarsale24Form ? (
          <></>
        ) : (
          <IframeResizer
            src={iframeSrc}
            checkOrigin={false}
            style={{
              width: '100%',
              minWidth: '100%',
              height: '100%',
              minHeight: '100%',
              border: 0,
            }}
          />
        )}
      </CarSale24Form>
    </IFrameContainerSt>
  </GridContainerSt>
);
